import { Bookstore } from '®shared/tenant';

import { LoadableBookstoreAvailability } from './bookstore-availability';

export class BookstoreAndAvailability {
  constructor(
    public bookstore: Bookstore,
    public availability: LoadableBookstoreAvailability,
  ) {}
}
